import { graphql } from "@/lib/gql/__generated__";

export const HostReceiptList_ManagementSalesReceiptsPage_Query = graphql(`
	query HostReceiptList_ManagementSalesReceiptsPage($hotelID: ID!) {
		hostReceiptList(hotelID: $hotelID) {
			id
			list {
				id
				receiptType
				uniqueID
				issuedAt
				isDownloadable
			}
		}
	}
`);
